// extracted by mini-css-extract-plugin
export default {"password":"css_password__KC+rZ"};